import promql from "refractor/promql";
export default promql;